import useSWR from 'swr';
import graphqlApi from '../api/graphqlApi';
import { NavigationMenuItem } from '../../models/NavigationMenuItem';
import { createShopifyMenuQuery } from './queries/shopifyMenu';

const useShopifyMenuSWR = (handle: string) => {
    const fetchAllMenuItem = (query): Promise<NavigationMenuItem[]> => {
        return graphqlApi
            .post(query)
            .then((res) => {
                return res && res.menu ? res.menu.items : [];
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        createShopifyMenuQuery(handle),
        fetchAllMenuItem,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    const convertData = (array): NavigationMenuItem => {
        return {
            id: 'main-menu',
            resourceId: null,
            title: null,
            type: null,
            url: null,
            items: array,
        };
    };

    return {
        menuItems: data ? convertData(data) : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useShopifyMenuSWR;
